import React from 'react';
import { useLocation, useOutlet } from 'react-router-dom';

// Le fondu de sortie global effacait la page avant que la suivante soit prete.
// Avec mode="wait", une page lazy n'etait meme montee qu'apres ce fade-out :
// son Suspense cachait ensuite l'animation et affichait brutalement le spinner.
// Le routeur utilise maintenant startTransition pour garder le contenu revele
// pendant le chargement du chunk. La cle garde les remounts par pathname (ex.
// nouveau brouillon apres edition d'une enquete), sauf le shell Resultats dont
// la cle reste fixe pour preserver la FilterBar. Crossfade reste utilise pour
// les onglets internes, qui ne changent pas de route.
export default function AnimatedOutlet({ transitionKey }) {
  const { pathname } = useLocation();
  const element = useOutlet();

  return <div key={transitionKey ?? pathname} data-vt-content>{element}</div>;
}
